import moment, { Moment } from 'moment';

import { SchoolHolidayTerm, SchoolHolidayType } from '../../legacy/types';

export const isWithinSchoolPeriod = (date: string | Moment, period: SchoolHolidayTerm) => {
  const startDate = moment(period.startDate);
  const endDate = moment(period.endDate);
  return moment(date).isBetween(startDate, endDate, 'seconds', '[)');
};

export const getCurrentSchoolPeriod = (
  upcomingTermsAndHolidays: Array<SchoolHolidayTerm>,
  periodTypes: SchoolHolidayType[],
  overrideCurrentDate?: string | Moment
) => {
  const filteredPeriods =
    upcomingTermsAndHolidays?.filter((period) => {
      return periodTypes.includes(period.type);
    }) || [];

  const currentDateOverride = overrideCurrentDate ? moment(overrideCurrentDate) : moment();
  const currentDate = currentDateOverride.isValid() ? currentDateOverride : moment();
  const currentPeriod = filteredPeriods?.find((period) => {
    return isWithinSchoolPeriod(currentDate, period);
  });

  return currentPeriod;
};

export const getUpcomingSchoolPeriod = (
  schoolTermsAndHolidays: Array<SchoolHolidayTerm>,
  periodTypes: SchoolHolidayType[],
  overrideCurrentDate?: string | Moment
) => {
  const currentDateOverride = overrideCurrentDate ? moment(overrideCurrentDate) : moment();
  const currentDate = currentDateOverride.isValid() ? currentDateOverride : moment();
  const upcomingPeriods =
    schoolTermsAndHolidays
      ?.filter((period) => {
        return periodTypes.includes(period.type) && moment(period.startDate).isAfter(currentDate, 'seconds');
      })
      ?.sort((a, b) => moment(a.startDate).diff(moment(b.startDate), 'seconds')) || [];

  return upcomingPeriods[0] || undefined;
};

export const getCurrentOrUpcomingSchoolPeriod = (
  upcomingTermsAndHolidays: Array<SchoolHolidayTerm>,
  periodTypes: SchoolHolidayType[],
  overrideCurrentDate?: string | Moment
) => {
  const currentDateOverride = overrideCurrentDate ? moment(overrideCurrentDate) : moment();
  const currentDate = currentDateOverride.isValid() ? currentDateOverride : moment();
  const currentPeriod = getCurrentSchoolPeriod(upcomingTermsAndHolidays, periodTypes, currentDate);
  if (currentPeriod) {
    return currentPeriod;
  }
  return getUpcomingSchoolPeriod(upcomingTermsAndHolidays, periodTypes, overrideCurrentDate);
};
